import { PermissionT } from "../types";

export const stateLicensesUpdates = (permissions: PermissionT[]): boolean => {
  const p = permissions.find((permission) => permission.name === "state_licenses_updates");
  return !!p;
};

export default stateLicensesUpdates;
